type SpinnerSubscriber = (isActive: boolean, count: number) => void;

class SpinnerStore {
  private count = 0;
  private subscribers: SpinnerSubscriber[] = [];

  subscribe(callback: SpinnerSubscriber) {
    this.subscribers.push(callback);

    callback(this.count > 0, this.count);

    return () => {
      this.subscribers = this.subscribers.filter(cb => cb !== callback);
    };
  }

  setSpinner(active: boolean) {
    if (active) {
      this.count++;
    } else {
      this.count = Math.max(0, this.count - 1);
    }
    this.notify();
  }

  private notify() {
    const isActive = this.count > 0;
    this.subscribers.forEach(cb => cb(isActive, this.count));
  }

  getState(): boolean {
    return this.count > 0;
  }

  getCount(): number {
    return this.count;
  }
}

export const spinnerStore = new SpinnerStore();
